import Loader from '@/components/common/loader/Loader';
import { useEffect, useRef, useState } from 'react';
import { PDFDocumentProxy } from 'pdfjs-dist/legacy/build/pdf.mjs';

interface IProps {
  pdfDocument: PDFDocumentProxy;
  page: number;
  width: number;
  height: number;
}

export const PageViewer = (props: IProps) => {
  const [isLoading, setIsLoading] = useState(true);

  const canvasRef = useRef<HTMLDivElement>();

  useEffect(() => {
    if (canvasRef.current) {
      setIsLoading(true);

      props.pdfDocument.getPage(props.page).then(function (page) {
        var testViewport = page.getViewport({
          scale: 1
        });

        const resolutionScaleFactor = 4;

        const scale =
          (props.width / testViewport.width) * resolutionScaleFactor;

        var viewport = page.getViewport({
          scale
        });

        var canvas = document.createElement('canvas');
        var context = canvas.getContext('2d');
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        canvas.style.height = `${viewport.height / resolutionScaleFactor}px`;
        canvas.style.width = `${viewport.width / resolutionScaleFactor}px`;

        var renderContext = {
          canvasContext: context,
          viewport: viewport
        };

        page.render(renderContext).promise.then(() => {
          if (canvasRef.current) {
            canvasRef.current.innerHTML = '';
            canvasRef.current.appendChild(canvas);
            setIsLoading(false);
          }
        });
      });
    }
  }, [props.page, canvasRef, props.width]);

  return (
    <div>
      {isLoading && (
        <div
          style={{
            width: props.width,
            height: props.height
          }}
          className="flex items-center justify-center bg-white"
        >
          <Loader />
        </div>
      )}
      <div
        style={{
          display: !isLoading ? 'block' : 'none'
        }}
      >
        <div ref={canvasRef}></div>
      </div>
    </div>
  );
};
